import useTranslate from '@hooks/useTranslate';
import { SurveyForm } from '@ui/organisms';
import SCREENS from '@constants/Screens';
import Screen from '@ui/templates/Screen';
import PropTypes from 'prop-types';
import CustomPropTypes from '@utils/CustomPropTypes';
import { useNavigation } from '@react-navigation/native';
import useToast from '@hooks/useToast';
import useSurveyQuery from '@hooks/queries/useSurveyQuery';
import { ActivityIndicator, View } from '@ui/atoms';
import useThemeColor from '@hooks/useThemeColor';

function EditSurveyScreen({ route }) {
  const toast = useToast();
  const { t } = useTranslate();
  const { navigate, goBack } = useNavigation();
  const primaryColor = useThemeColor('$primary.main');

  const { id } = route.params || {};

  const { data: survey, isLoading } = useSurveyQuery(id);

  const handleSuccess = (updatedSurvey) => {
    toast.success(t('EditSurveyScreen.success'));
    goBack();
    navigate(SCREENS.survey, { id: updatedSurvey.id });
  };

  return (
    <Screen title={t('EditSurveyScreen.title')} presentation={EditSurveyScreen.presentation} scrollable>
      {isLoading ? (
        <View
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: '$8',
          }}
        >
          <ActivityIndicator size="large" color={primaryColor} />
        </View>
      ) : (
        <SurveyForm survey={survey} onSuccess={handleSuccess} />
      )}
    </Screen>
  );
}

EditSurveyScreen.presentation = 'modal';
EditSurveyScreen.screenName = SCREENS.editSurvey;

EditSurveyScreen.propTypes = {
  route: PropTypes.shape({
    params: PropTypes.shape({
      id: CustomPropTypes.uuid.isRequired,
    }),
  }).isRequired,
};

export default EditSurveyScreen;
